<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="supply_official_tooltip_name"
      :name="supply_official_tooltip_name" :description="supply_official_tooltip_description"
      :editable="editable"></tool-tip>

    <div class="row justify-content-center">
      <div class="col-sm-6 signature_content_padding_top">
        <label for="name"> Name (Last, First, MI, Rank / Title)</label>
        <base-input id="name" :disabled="isReadOnly || isInvoiced || checkForPartnerNationCondition" data-vv-as="Name"
          v-model="supplyOfficial.supplierName" name="name" v-validate="'required|max:300'" :error="getError('name')">
        </base-input>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <label for="supplyOffice">Supply Unit / Office</label>
        <base-input id="supplyOffice" data-vv-as="Supply Unit / Office"
          :disabled="isReadOnly || isInvoiced || checkForPartnerNationCondition"
          v-model="supplyOfficial.supplierUnitOffice" name="unitOffice" v-validate="'required|max:300'"
          :error="getError('unitOffice')">
        </base-input>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <label for="supplyNation">Supply Nation / Organization</label>
        <v-select id="supplyNation" :disabled="isReadOnly || isInvoiced || checkForPartnerNationCondition"
        v-model="supplyOfficial.supplierOrganizationId"   
        :options="supplyNationOptions"
        :reduce="(country) => country.id"
                        label="name" 
        name="supplyNation" placeholder="Select one"
        
          :class="errors.has('supplyNation') ? 'has-danger' : ''" v-validate="'required'"
          :error="getError('supplyNation')"></v-select>
        <span v-show="errors.has('supplyNation')" class="error">Supply Nation / Organization is required
        </span>
      </div>
      <div class="col-sm-6 signature_content_padding_top">
        <!-- verify Pin Code -->
        
      <verify-pin v-if="isSigned" :checkForPartnerNationCondition="checkForPartnerNationCondition" :isPartnerAccount="isPartnerAccount" :isReadOnly="isReadOnly"  v-on:pinVerify="pinVerify"/>
          
          <AlertSignature ref="alertSupplyOfficialSignatureGraphical" :headerText="'Supply Official Signature'"
          :module="'supplyOfficial'" :action="'getSupplyOfficial'" :activeTab="supplyOfficial.supplierSignature.type"
          v-on:onUpload="fileUploaded"
          v-on:onSigned="onSigned"
          :signatureData="supplyOfficial.supplierSignature" :fileTypeId="3"
          :isPinVerified="isPinVerificationDone"
          :textDisabled="checkForPartnerNationCondition || isInvoiced || isReadOnly"
          :drawDisabled="checkForPartnerNationCondition || isInvoiced || isReadOnly"
        :uploadDisabled="checkForPartnerNationCondition || isInvoiced || isReadOnly || isPartnerAccount"
          :certificateDisabled="isInvoiced || isReadOnly || !signedInWithCac" />
        <label style="margin-left: 5px; margin-right: 5px" v-if="isBuyTransaction && !isPartnerAccount">or</label>
        
        <request-signature :signatureUrl="`api/supplysignatures/request/${getOrderIdFromRoute}`"
          v-bind:moduleSubmit="submit"
          :requestDate="supplyOfficial.supplierDateRequested"
          :isDisabled="isRequestDisabled"
          v-if="isBuyTransaction && !isPartnerAccount"></request-signature>

        <div v-if="hasSignatureImage() " class="container signature_content_padding_top_small signature_field">
          <div class="row justify-content-end">
            <delete-signature :headerText="'Are you sure you want to remove the Invoice Signature?'"
            :signatureId="supplyOfficial.supplierSignature.signatureId"
            :fileTypeId="3"
            :signatureType="supplyOfficial.supplierSignature.type"
            :disabled=" isPartnerAccount || isInvoiced"
            v-on:modal-closed="reloadData"></delete-signature>
          </div>

          <img class="image_layout" :src="supplyOfficial.supplierSignature.view" height="100">
        </div>

        <div>
          <div class="content_padding_top_small">
            <label for="signatureDate">Signature Date</label>
            <el-date-picker id="signatureDate"
              :disabled="(isInvoiced && !isLegacyOrder) || isReadOnly || checkForPartnerNationCondition || (!isRelevantDocumentUploaded && !fileUploadedBoolean)"
              v-model="supplyOfficial.supplierDateSigned" type="date" :editable="false" format="dd-MMMM-yyyy"
              data-vv-as="Signature Date" name="dateSigned" :class="errors.has('dateSigned') ? 'has-danger' : ''"
              :error="getError('dateSigned')">
            </el-date-picker>
            <span v-show="errors.has('dateSigned')" class="error">Signature Date is required
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12 signature_content_padding_top">
        <div class="pull-right">
          <base-button :disabled="isReadOnly || isInvoiced || checkForPartnerNationCondition || isInvoiced" type="primary"
            wide @click.native="submit" class="btn-next">Save</base-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";
import RequestSignature from "@/components/App/signatures/RequestSignature.vue";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";
import VerifyPin from '@/components/App/order/VerifyPin.vue';
import { mapGetters, mapActions } from "vuex";
import { Button } from "element-ui";
import { EventBus } from "@/event-bus.js";
import Util from "@/util/util";
import toolTip from "../../Tooltip";


export default {
  props: ["isReadOnly"],
  name: "SupplyOfficial",
  data() {
    return {
      isBuyTransaction: true,
      supply_official_tooltip_description: '',
      supply_official_tooltip_name: '',
      dtype: null,
      fileUploadedBoolean: false,
      isPinVerificationDone: false,
      pin: null,
      sigHasSigned: false
    };
  },

  components: {
    AlertSignature,
    DeleteSignature,
    toolTip,
    [Button.name]: Button,
    VerifyPin,
    RequestSignature
  },
  async mounted() {
    let ctx = this;
    
    // Load organizations first so dropdown options are available when the saved value is loaded
    await this.loaded();
    
    EventBus.$on('pn-user-change', async (value) => {
      this.loadSupplyOfficial(this.getOrderIdFromRoute);
    });

    EventBus.$on('doc-type-change', async() => {
      ctx.$loaderApp.addRequest();
      await ctx.getSupplyOfficialStatus(ctx.$route.params.id);
      ctx.$loaderApp.completeRequest();
    });
    await ctx.getAllTooltips();
    ctx.loadToolTips();
  },

  computed: {
    ...mapGetters({
      supplyOfficial: "supplyOfficial/supplyOfficial",
      supplyOfficialErrors: "supplyOfficial/supplyOfficialErrors",
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus:
        "agreementInformation/agreementInformationStatus",
      supplyOfficialHelper: "supplyOfficial/supplyOfficialHelper",
      documents: "documents/getDocuments",
      preOrder: "preOrderDetail/preOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      getUser: "authentication/getUser",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isUsSellOrder: "preOrderDetail/isUsSellOrder",
      isReturned: "orderMetadata/isReturned",
      isReceived: "orderMetadata/isReceived",
      orderMetadata: "orderMetadata/orderMetadata",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",
      documentTypes: "documents/documentTypes",
    }),
    isSigned() {
      if(this.supplyOfficial.supplierDateRequested){
        if(!this.supplyOfficial.supplierSignature.signatureId){
          return true
        }else return false
      }else return false
    },
    isRequestDisabled() {
      var skipReturned = this.orderMetadata.paymentMethodId === Util.MONETARY;

      var ret = 
        !this.supplyOfficial.supplierName || 
        !this.supplyOfficial.supplierUnitOffice || 
        !this.supplyOfficial.supplierOrganizationId ||
        (this.supplyOfficial.supplierDateRequested ? true : false) || 
        (this.supplyOfficial.supplierSignature.view ? true : false) || 
        (skipReturned ? !this.isReceived : !this.isReturned) || 
        this.isReadOnly;
  
        return ret;

    },
    isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
    supplyNationOptions(){
      return this.supplyOfficial.organizations
    },
     checkForPartnerNationCondition() {
       if (this.isPartnerAccount && this.isUsBuyOrder) {
         if (this.supplyOfficial.supplierDateRequested == null) {
           return true;
         }
         return false;
      } else if(this.isPartnerAccount && this.isUsSellOrder) {
        return true;
      }

      return false;
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isInvoiced() {
      if (this.orderMetadata) {
        return ["INVOICED", "BILLED", "COMPLETED"].includes(
          `${this.orderMetadata.orderStatus}`
        );
      }
    },
    signedInWithCac() {
      return this.getUser.loginMethod == "CAC";
    },

    isRelevantDocumentUploaded() {
      if (this.documents && this.documents.length > 0) {
        return this.documents.some(document => {
          return document.fileTypeNames.some(doc => doc === Util.INVOICE) ||
            document.fileTypeNames.some(doc => doc == Util.ORDER_STATUS_INVOICED);
        });
      }
      return false
    },
    signatureDateAddedWithSignatureOrDocumentUploaded() {
      return this.isRelevantDocumentUploaded || this.hasSignatureImage() || this.signedInWithCac;
    }
  },
  methods: {
    ...mapActions({
      loadSupplyOfficial: "supplyOfficial/getSupplyOfficial",
      getSupplyOfficialStatus: "supplyOfficial/getSupplyOfficialStatus",
      getSupplyOfficialHelper: "supplyOfficial/getSupplyOfficialHelper",
      saveSupplyOfficialToServer: "supplyOfficial/saveSupplyOfficial", 

      getAllTooltips: "tooltip/getToolTips",
      getSupplyOfficialSigOnly: "supplyOfficial/getSupplyOfficialSigOnly"
    }),
    pinVerify(val, pin) {
      this.isPinVerificationDone = val;
      this.pin = pin;
    },
   
    async onSigned() {
      // complete the request
      this.sigHasSigned = true;
      await this.submit();
      // only pn user will use this
      this.pin = null;
    },
    async fileUploaded() {
      this.fileUploadedBoolean = true;
      await this.getSupplyOfficialSigOnly(this.getOrderIdFromRoute);
      await this.submit();
      this.$loaderApp.completeRequest();

    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'INVOICE')
    },
    loadToolTips() {
      const supplyToolTip = this.toolTips.find(e => e.name === "SupplySignatureModule")
      if (supplyToolTip.status) {
        this.supply_official_tooltip_description = supplyToolTip.description ? supplyToolTip.description : null
        this.supply_official_tooltip_name = supplyToolTip.name ? supplyToolTip.name : null

      }
      return
    },
    updateToolTip(updatedData) {
      this.loadToolTips()
    },
    async loaded() {
      let ctx = this;

      await ctx.getSupplyOfficialHelper(ctx.getOrderIdFromRoute);
      
      const params = {
        buySell: ctx.supplyOfficialHelper.buySell,
        countryId: ctx.supplyOfficialHelper.countryId,
        preOrderDetailStatus: ctx.preOrderStatus,
        agreementInformationStatus: ctx.agreementInformationStatus,
      };

      this.isBuyTransaction = params.buySell == "BUY";

      await ctx.$store.dispatch(
        "supplyOfficial/getOrganizations",
        params
      );
      
      await ctx.loadSupplyOfficial(ctx.getOrderIdFromRoute);
    },
    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.supplyOfficial.supplierSignature.view);
    },

    showSupplyOfficialErrors() {
      if (this.supplyOfficialErrors.length > 0) {
        this.supplyOfficialErrors.forEach(error => this.$toast.error(error))
      } else {
        this.$toast.success("Supply Official Module signature saved successfully");
      }
    },

    async reloadData() {
      await this.getSupplyOfficialStatus(this.getOrderIdFromRoute);
        await this.loadSupplyOfficial(this.getOrderIdFromRoute);
    },

    async submit(e) {
      let result = await this.$validator.validateAll();
      if (result) {
        if (!this.signatureDateAddedWithSignatureOrDocumentUploaded && this.supplyOfficial.supplierDateSigned) {
          this.supplyOfficial.supplierDateSigned = null;
          this.$toast.error(Util.SIGNATURE_DATE_ADDED_WITHOUT_SIGNATURE_OR_DOCUMENT_UPLOADED);
        }
        let ctx = this;
        let data = {
          orderId: this.getOrderIdFromRoute,
          pin: (this.sigHasSigned || this.fileUploadedBoolean) ? this.pin : ''
        }
      this.$loaderApp.addRequest();

        await this.saveSupplyOfficialToServer(data);
        await ctx.getSupplyOfficialStatus(ctx.getOrderIdFromRoute);
        ctx.showSupplyOfficialErrors();
        await ctx.loadSupplyOfficial(ctx.getOrderIdFromRoute);
        this.$loaderApp.completeRequest();

      } else {
        this.$loaderApp.completeRequest();
        this.$toast.error("Please fill the form required fields.");
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
};
</script>

<style scopped>
.row {
  margin-right: 0px!important;
  margin-left: 0px!important;
}
</style>
